// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"72367363","787":"cde50072"}[chunkId] + ".chunk.js";
};